import { UserCredential } from "../UserCredential";

export type IUserCredentialDto = Omit<UserCredential, 'creationDate' | 'creationUser'| 'modificationDate' | 'modificationUser'>

export class UserCredentialDto implements IUserCredentialDto {
    account: string;
    password: string;
    name: string;
    description: string;
    email: string;
    phone: string;
    isActiveDirectory: boolean;
    domain: string;
    isAPIUser?: boolean | null;
    isCustomUser?: boolean | null;
    position?: string;
    status?: number | null;

    constructor() {
        this.isActiveDirectory = false;
        this.isAPIUser = false;
        this.isCustomUser = false
    }
}